export enum DeepLinkType {
  ALERT = 'ALERT',
  PREFCENTER = 'PREFCENTER',
}
